var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.9 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.15,200h-12.5c-.5-.11-1-.28-1.5-.32-21.84-1.78-41.23-9.62-57.62-24.15C8.89,152.78-2.52,124.05.46,89.94c1.86-21.31,10.23-40.12,24.51-56.06C44.47,12.09,68.98.74,98.22.03c18.92-.46,36.67,4.17,52.81,14.06,25.86,15.85,41.75,38.75,47.33,68.66.68,3.63,1.03,7.32,1.54,10.99v12.5c-.16,1.28-.34,2.56-.48,3.85-2.14,19.78-9.31,37.53-21.93,52.91-15.7,19.13-35.78,31.01-60.17,35.45-3.69.67-7.44,1.04-11.17,1.55ZM158.54,151.05c.03-.68.09-1.25.09-1.83,0-13.28.03-26.56-.02-39.83-.01-2.73-.2-5.47-.53-8.17-1.75-14.26-10.29-23.23-24.04-24.84-9.54-1.11-17.77,1.6-23.76,9.58-.41.55-.83,1.08-1.63,2.13v-10.12h-24.22v73.08h24.23v-2.41c0-9.76-.01-19.53,0-29.29,0-3.84,0-7.68.16-11.52.19-4.41,2.41-7.8,5.93-10.26,7.01-4.91,16.1-1.81,18.43,6.39.77,2.71,1.03,5.64,1.06,8.47.11,12.17.05,24.34.05,36.51,0,.69,0,1.38,0,2.11h24.25ZM46.61,77.85v73.19h24.26v-2.43c0-22,0-44.01,0-66.01,0-.98-.09-1.96.02-2.93.16-1.5-.47-1.86-1.89-1.85-6.38.07-12.76.03-19.14.03-1.03,0-2.06,0-3.25,0ZM45.09,55.31c.05,7.41,5.75,12.66,13.68,12.59,7.97-.07,13.77-5.43,13.7-12.66-.08-7.5-5.81-12.74-13.85-12.67-7.99.07-13.57,5.34-13.53,12.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.60e8893f521b5d9ff95d96b206125921.svg";
export { ForwardRef as ReactComponent };